module.exports = __webpack_public_path__ + "static/w-dian-8f3f94645fae94beafeaab40f989876e.jpg";